















































































































































import { Vue, Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import filesaver from 'file-saver';
import MyList from '@/mixins/list';

import SelectStadium from '@/components/selectstadium.vue';
import Audit from '@/views/finacy/audit.vue';
import AuditNew from '@/views/finacy/audit_new.vue';

@Component({
  components: {
    SelectStadium,
    Audit,
    AuditNew,
  },
})
export default class extends Mixins(MyList) {
  stadiumId = 0;

  stadiumName = '';

  checkModalVisible = false;

  newCheckModalVisible = false;

  newCheckModalVisible1 = false;

  compareresult = false;

  oldData: any = null;

  dispatchType = 'finance/getProfitSettlements';

  columns: any[] = [
    { title: '编号', dataIndex: 'id' },
    { title: '场馆名称', scopedSlots: { customRender: 'stadium_name' } },
    { title: '头像', scopedSlots: { customRender: 'manager_avatar' } },
    { title: '馆长', scopedSlots: { customRender: 'manager_username' } },
    { title: '申请时间', dataIndex: 'created_time' },
    { title: '申请开始时间', dataIndex: 'date_from' },
    { title: '申请结束时间', dataIndex: 'date_end' },
    { title: '结算金额', scopedSlots: { customRender: 'earning' } },
    { title: '状态', scopedSlots: { customRender: 'is_check' } },
    { title: '操作', scopedSlots: { customRender: 'action' } },
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  moment: (...args: any[]) => any = moment;

  showCheckModal(record: any) {
    if (!this.checkPermission('admin-audit-settlement')) {
      this.$message.warning('没有权限');
      return;
    }
    // console.log('222')
    // console.log(this.oldData)
    // console.log(this.checkModalVisible)
    this.oldData = record;
    this.checkModalVisible = true;
  }

  hideCheckModal() {
    // console.log('hide')
    this.checkModalVisible = false;
    this.loadData({
      settle_type: 1,
    });
  }

  showNewCheckModal(record: any) {
    this.oldData = record;
    this.newCheckModalVisible = true;
  }

  hideNewCheckModal() {
    this.newCheckModalVisible = false;
    this.loadData({
      settle_type: 1,
    });
  }

  showNewCheckModal1(stadiumId: number, stadiumName: string) {
    this.stadiumId = stadiumId;
    this.stadiumName = stadiumName;
    this.newCheckModalVisible1 = true;
  }

  hideNewCheckModal1() {
    this.newCheckModalVisible1 = false;
  }

  mounted() {
    this.loadData({
      settle_type: 1,
    });
  }

  handleBeforeUpload(file: any) {
    const params = new FormData();
    params.append('chunk', '0');
    params.append('chunks', '1');
    params.append('filename', file, file.name);
    // params.append("settlement_id", this.oldData.id);
    this.$store
      .dispatch('finance/compareProfitSettlement', params)
      .then((res: any) => {
        if (res && res.Message && res.Message === 'success') {
          this.compareresult = true;

          this.loadData();
        }
      });
    return false;
  }

  async exportExcel() {
    this.$confirm({
      title: '确认信息',
      content: '确认导出吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('finance/exportSettlements', {
          settle_type: 1,
          ...this.searchData,
        });
        // console.log(res)
        if (res && res.data) {
          const blob = new Blob([res.data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          filesaver.saveAs(
            blob,
            `结算记录${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
          );
        }
      },
    });
  }
}
